import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Creator {
  id: number;
  name: string;
  avatar: string;
  cover: string;
  category: string;
  subscribers: number;
  minPrice: number;
  isSubscribed: boolean;
}

export default function Explore() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: '전체', icon: 'ri-grid-line' },
    { id: 'daily', name: '일상/브이로그', icon: 'ri-camera-line' },
    { id: 'art', name: '아트/일러스트', icon: 'ri-palette-line' },
    { id: 'fitness', name: '운동/헬스', icon: 'ri-heart-pulse-line' },
    { id: 'gaming', name: '게임/스트리밍', icon: 'ri-gamepad-line' },
    { id: 'beauty', name: '뷰티/메이크업', icon: 'ri-brush-line' },
    { id: 'music', name: '음악/커버', icon: 'ri-music-line' },
  ];

  const allCreators: Creator[] = [
    {
      id: 1,
      name: '민지',
      avatar: 'https://public.readdy.ai/ai/img_res/f548c036cf6a549d0fd84896797a261c.jpg',
      cover: 'https://readdy.ai/api/search-image?query=soft%20pastel%20pink%20purple%20gradient%20abstract%20background%20with%20sparkles%20dreamy%20aesthetic%20smooth%20texture%20elegant%20minimalist%20design&width=400&height=500&seq=explore1cover&orientation=portrait',
      category: '일상/브이로그',
      subscribers: 1250,
      minPrice: 9900,
      isSubscribed: false,
    },
    {
      id: 2,
      name: '하늘',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20artist%20content%20creator%20profile%20picture%20with%20purple%20lighting%20creative%20aesthetic%20professional%20photo%20clean%20background&width=200&height=200&seq=explore2&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=dreamy%20purple%20blue%20gradient%20background%20with%20soft%20glow%20aesthetic%20pastel%20colors%20smooth%20abstract%20design%20elegant%20minimalist&width=400&height=500&seq=explore2cover&orientation=portrait',
      category: '아트/일러스트',
      subscribers: 890,
      minPrice: 12000,
      isSubscribed: false,
    },
    {
      id: 3,
      name: '서연',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20fitness%20creator%20profile%20photo%20with%20bright%20lighting%20healthy%20athletic%20look%20professional%20headshot%20clean%20background&width=200&height=200&seq=explore3&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=soft%20pink%20coral%20gradient%20background%20with%20gentle%20sparkles%20fitness%20aesthetic%20smooth%20pastel%20colors%20elegant%20minimalist%20design&width=400&height=500&seq=explore3cover&orientation=portrait',
      category: '운동/헬스',
      subscribers: 2100,
      minPrice: 15000,
      isSubscribed: false,
    },
    {
      id: 4,
      name: '지우',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20gaming%20streamer%20profile%20picture%20with%20neon%20lighting%20playful%20expression%20professional%20photo%20clean%20background&width=200&height=200&seq=explore4&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=vibrant%20purple%20pink%20gradient%20background%20with%20digital%20glow%20gaming%20aesthetic%20smooth%20pastel%20colors%20modern%20minimalist%20design&width=400&height=500&seq=explore4cover&orientation=portrait',
      category: '게임/스트리밍',
      subscribers: 3400,
      minPrice: 8900,
      isSubscribed: false,
    },
    {
      id: 5,
      name: '유나',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20beauty%20creator%20profile%20photo%20with%20soft%20lighting%20makeup%20artist%20professional%20headshot%20elegant%20clean%20background&width=200&height=200&seq=explore5&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=elegant%20pink%20rose%20gradient%20background%20with%20soft%20sparkles%20beauty%20aesthetic%20smooth%20pastel%20colors%20luxurious%20minimalist%20design&width=400&height=500&seq=explore5cover&orientation=portrait',
      category: '뷰티/메이크업',
      subscribers: 1800,
      minPrice: 11000,
      isSubscribed: false,
    },
    {
      id: 6,
      name: '채원',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20music%20creator%20profile%20picture%20with%20purple%20lighting%20artistic%20expression%20professional%20photo%20clean%20background&width=200&height=200&seq=explore6&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=dreamy%20lavender%20purple%20gradient%20background%20with%20musical%20notes%20aesthetic%20smooth%20pastel%20colors%20artistic%20minimalist%20design&width=400&height=500&seq=explore6cover&orientation=portrait',
      category: '음악/커버',
      subscribers: 950,
      minPrice: 13000,
      isSubscribed: false,
    },
    {
      id: 7,
      name: '수아',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20lifestyle%20creator%20profile%20photo%20with%20warm%20lighting%20natural%20beauty%20professional%20headshot%20clean%20background&width=200&height=200&seq=explore7&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=soft%20peach%20pink%20gradient%20background%20with%20gentle%20glow%20lifestyle%20aesthetic%20smooth%20pastel%20colors%20warm%20minimalist%20design&width=400&height=500&seq=explore7cover&orientation=portrait',
      category: '일상/브이로그',
      subscribers: 1560,
      minPrice: 10000,
      isSubscribed: false,
    },
    {
      id: 8,
      name: '예린',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20female%20dance%20creator%20profile%20picture%20with%20dynamic%20lighting%20energetic%20expression%20professional%20photo%20clean%20background&width=200&height=200&seq=explore8&orientation=squarish',
      cover: 'https://readdy.ai/api/search-image?query=vibrant%20pink%20purple%20gradient%20background%20with%20energy%20waves%20dance%20aesthetic%20smooth%20pastel%20colors%20dynamic%20minimalist%20design&width=400&height=500&seq=explore8cover&orientation=portrait',
      category: '음악/커버',
      subscribers: 2890,
      minPrice: 14000,
      isSubscribed: false,
    },
  ];

  const filteredCreators = allCreators.filter(creator => {
    const matchesSearch = creator.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         creator.category.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || 
                           creator.category.includes(categories.find(c => c.id === selectedCategory)?.name.split('/')[0] || '');
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-white relative">
      {/* Subtle Background */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-pink-50/20 via-purple-50/10 to-blue-50/20"></div>
        <div className="absolute inset-0 opacity-[0.015]" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(236, 72, 153, 0.3) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-pink-200/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-200/10 rounded-full blur-3xl"></div>
      </div>

      {/* Top Navigation */}
      <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/fan/dashboard" className="flex items-center gap-2">
              <i className="ri-arrow-left-line text-2xl text-gray-700"></i>
            </Link>
            <h1 className="text-xl font-bold text-gray-900">탐색</h1>
            <div className="w-8"></div>
          </div>
        </div>
      </nav>

      <div className="max-w-6xl mx-auto px-4 py-6 relative">
        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="크리에이터 검색..."
              className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-pink-500 focus:bg-white transition-all text-sm"
            />
          </div>
        </div>

        {/* Category Filter */}
        <div className="mb-8 overflow-x-auto">
          <div className="flex gap-3 pb-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full font-semibold whitespace-nowrap transition-all ${
                  selectedCategory === category.id
                    ? 'bg-gray-900 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span className="text-sm">{category.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Results Count */}
        <div className="mb-4">
          <p className="text-sm text-gray-600">
            {filteredCreators.length}명의 크리에이터
          </p>
        </div>

        {/* Creators Grid */}
        {filteredCreators.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
              <i className="ri-search-line text-4xl text-gray-400"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">검색 결과가 없습니다</h3>
            <p className="text-gray-600">다른 검색어로 시도해보세요</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pb-20">
            {filteredCreators.map((creator) => (
              <Link
                key={creator.id}
                to={`/fan/creator/${creator.id}`}
                className="group"
              >
                <div className="bg-white/50 backdrop-blur-sm rounded-2xl overflow-hidden border border-gray-100 hover:shadow-lg transition-all">
                  {/* Cover Image */}
                  <div className="relative w-full aspect-[4/5] overflow-hidden bg-gray-100">
                    <img
                      src={creator.cover}
                      alt={creator.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                    
                    {/* Creator Info Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white">
                          <img
                            src={creator.avatar}
                            alt={creator.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-white truncate">{creator.name}</h3>
                          <p className="text-xs text-white/80 truncate">{creator.category}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Stats */}
                  <div className="p-3">
                    <div className="flex items-center justify-between text-xs text-gray-600 mb-2">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {creator.subscribers.toLocaleString()}
                      </span>
                      <span className="font-semibold text-gray-900">
                        {creator.minPrice.toLocaleString()}원/월
                      </span>
                    </div>
                    <button className="w-full py-2 bg-gray-900 text-white text-sm font-semibold rounded-lg hover:bg-gray-800 transition-all whitespace-nowrap">
                      구독하기
                    </button>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
